import actions from './actions'
import mutations from './mutations'
import state from './state'

export const applicationVehicle = {
  actions,
  mutations,
  namespaced: true,
  state
}
